<template>
  <div class="thesite"
			 :class="langClass">
    <NuxtLoadingIndicator />
    <the-header :content="headerNavigation" />
    <div class="content">
      <slot />
    </div>
    <the-footer :content="footerSubNav" />
    <div class="nav__bg" :class="navOpen === true ? 'nav--active' : ''" @click="$toggleNav"></div>
  </div>
</template>

<script setup>
import { useI18n } from '#imports'
import { groq } from "@nuxtjs/sanity/runtime/groq"
import {computed} from "vue";
const query = groq`{
  'navigation': *[_type == 'navigation']{
    mainLinksTitle,
    mainLinks[]->{
      text,
      slug
    },
    aboutLinksTitle,
    aboutLinks[]->{
      text,
      slug
    },
    servicesLinksTitle,
    servicesLinks[]->{
      text,
      slug
    },
    navProject->{
      title,
      slug,
      projectType,
      projectHero{
        asset->{
          metadata{
            dimensions{
              height,
              width
            }
          },
          url
        }
      },
      projectHeroAlt
    },
  },
  'newsletter': *[_type == 'newsLetter'] | order(_publishedAt desc){
    title,
    slug,
    thumb{
      asset->{
        metadata{
          dimensions{
            height,
            width
          }
        },
        url
      }
    },
    thumbAlt,
    publishedAt
  }[0],
  'footerSubNav': *[_type == 'subNavigation' && title == 'Footer']{
    subNavigationReference[]->{
      href,
      slug,
      text,
      target
    }
  }
}`
const sanity = useSanity()
const { data } = await useAsyncData('navigation', () => sanity.fetch(query))
const headerNavigation = computed(() => data.value ?? {})
const footerSubNav = computed(() => data.value?.footerSubNav?.[0]?.subNavigationReference ?? [])
const navOpen = useState('false')
const { locale } = useI18n()
let langClass	= computed(() => locale.value === 'en' ? 'body--en' : 'body--jp' )
</script>
